import {
    CREATE_CAMPAIGN,
    CREATE_CAMPAIGN_FAILURE,
    CREATE_CAMPAIGN_SUCCESS,
} from 'store/actions/types';

export const createCampaign = (payload) => {
    return {
        type: CREATE_CAMPAIGN,
        payload: payload,
    };
};

export const createCampaignFailure = (error) => {
    return {
        type: CREATE_CAMPAIGN_FAILURE,
        error: error,
    };
};

export const createCampaignSuccess = (payload) => {
    return {
        type: CREATE_CAMPAIGN_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaigns/createCampaigns.js